import { resolveImageUrl } from '../../../utils/image';

type OrderCategoryRow = { id: number; name: string; sort_order: number };
type OrderProductRow = { id: number; name: string; sort_order: number; images: string[] };
type CategoryItem = { id: number; name: string };

type Props = {
  orderCategoryRows: OrderCategoryRow[];
  orderProductRows: OrderProductRow[];
  orderSelectedCategoryId: number | null;
  categories: CategoryItem[];
  orderSaving: boolean;
  canReorder: boolean;
  orderAllValue: number;
  onSelectCategory: (id: number | null) => void;
  onSetCategoryPos: (rowId: number, newPos: number) => void;
  onSetProductPos: (rowId: number, newPos: number) => void;
  onMoveCategory: (index: number, direction: 'up' | 'down') => void;
  onMoveProduct: (index: number, direction: 'up' | 'down') => void;
  onSaveCategoryOrder: () => void;
  onSaveProductOrder: () => void;
  onResetDrafts: () => void;
};

export default function CatalogReorderSection(props: Props) {
  const {
    orderCategoryRows,
    orderProductRows,
    orderSelectedCategoryId,
    categories,
    orderSaving,
    canReorder,
    orderAllValue,
    onSelectCategory,
    onSetCategoryPos,
    onSetProductPos,
    onMoveCategory,
    onMoveProduct,
    onSaveCategoryOrder,
    onSaveProductOrder,
    onResetDrafts,
  } = props;

  return (
    <div className="admin-order-tab">
      <div className="admin-card" style={{ marginBottom: 20 }}>
        <h2 className="admin-card-title">Порядок категорий</h2>
        <p className="admin-order-hint">Порядок категорий: число или стрелки ↑↓. При сдвиге товары ниже спускаются.</p>
        <div className="admin-order-list">
          {orderCategoryRows.map((row, idx) => (
            <div key={row.id} className="admin-order-row admin-order-row-compact">
              <span className="admin-order-name">{row.name}</span>
              <label className="admin-order-input-wrap">
                <span className="admin-order-label">№</span>
                <input
                  type="number"
                  min={0}
                  max={orderCategoryRows.length - 1}
                  className="admin-input admin-order-input admin-order-input-sm"
                  value={row.sort_order}
                  onChange={(e) => {
                    const v = parseInt(e.target.value, 10);
                    if (Number.isFinite(v)) onSetCategoryPos(row.id, v);
                  }}
                />
              </label>
              <div className="admin-order-arrows">
                <button type="button" className="admin-btn admin-btn-secondary admin-btn-sm admin-order-arrow" disabled={idx === 0} onClick={() => onMoveCategory(idx, 'up')} title="Выше">↑</button>
                <button type="button" className="admin-btn admin-btn-secondary admin-btn-sm admin-order-arrow" disabled={idx === orderCategoryRows.length - 1} onClick={() => onMoveCategory(idx, 'down')} title="Ниже">↓</button>
              </div>
            </div>
          ))}
        </div>
        <button type="button" className="admin-btn admin-btn-primary" onClick={onSaveCategoryOrder} disabled={!canReorder || orderSaving || orderCategoryRows.length === 0}>
          {orderSaving ? 'Сохранение…' : 'Сохранить порядок категорий'}
        </button>
        <button type="button" className="admin-btn admin-btn-secondary" onClick={onResetDrafts} disabled={orderSaving}>Сбросить черновик</button>
      </div>

      <div className="admin-card">
        <h2 className="admin-card-title">Порядок товаров в категории</h2>
        <p className="admin-order-hint">Выберите категорию. Порядок: число или стрелки ↑↓. При сдвиге остальные опускаются.</p>
        <div className="admin-order-category-btns">
          <button type="button" className={`admin-btn ${orderSelectedCategoryId === orderAllValue ? 'admin-btn-primary' : 'admin-btn-secondary'}`} onClick={() => onSelectCategory(orderSelectedCategoryId === orderAllValue ? null : orderAllValue)}>
            Все товары
          </button>
          <button type="button" className={`admin-btn ${orderSelectedCategoryId === 0 ? 'admin-btn-primary' : 'admin-btn-secondary'}`} onClick={() => onSelectCategory(orderSelectedCategoryId === 0 ? null : 0)}>
            Без категории
          </button>
          {categories.map((c) => (
            <button key={c.id} type="button" className={`admin-btn ${orderSelectedCategoryId === c.id ? 'admin-btn-primary' : 'admin-btn-secondary'}`} onClick={() => onSelectCategory(orderSelectedCategoryId === c.id ? null : c.id)}>
              {c.name}
            </button>
          ))}
        </div>
        {orderSelectedCategoryId !== null && (
          <>
            <div className="admin-order-list admin-order-products">
              {orderProductRows.map((row, idx) => (
                <div key={row.id} className="admin-order-row admin-order-product-row">
                  <div className="admin-order-product-thumb">
                    {row.images?.[0] ? <img src={resolveImageUrl(row.images[0])} alt="" /> : <div className="admin-order-product-thumb-placeholder" />}
                  </div>
                  <div className="admin-order-product-info">
                    <span className="admin-order-product-name">{row.name}</span>
                  </div>
                  <label className="admin-order-input-wrap">
                    <span className="admin-order-label">№</span>
                    <input
                      type="number"
                      min={0}
                      max={orderProductRows.length - 1}
                      className="admin-input admin-order-input admin-order-input-sm"
                      value={row.sort_order}
                      onChange={(e) => {
                        const v = parseInt(e.target.value, 10);
                        if (Number.isFinite(v)) onSetProductPos(row.id, v);
                      }}
                    />
                  </label>
                  <div className="admin-order-arrows">
                    <button type="button" className="admin-btn admin-btn-secondary admin-btn-sm admin-order-arrow" disabled={idx === 0} onClick={() => onMoveProduct(idx, 'up')} title="Выше">↑</button>
                    <button type="button" className="admin-btn admin-btn-secondary admin-btn-sm admin-order-arrow" disabled={idx === orderProductRows.length - 1} onClick={() => onMoveProduct(idx, 'down')} title="Ниже">↓</button>
                  </div>
                </div>
              ))}
            </div>
            <button type="button" className="admin-btn admin-btn-primary" onClick={onSaveProductOrder} disabled={!canReorder || orderSaving || orderProductRows.length === 0}>
              {orderSaving ? 'Сохранение…' : 'Сохранить порядок товаров'}
            </button>
            <button type="button" className="admin-btn admin-btn-secondary" onClick={onResetDrafts} disabled={orderSaving}>Сбросить черновик</button>
          </>
        )}
        {orderSelectedCategoryId !== null && orderProductRows.length === 0 && <p className="admin-order-hint">В этой категории нет товаров</p>}
      </div>
    </div>
  );
}

